import React from 'react';
import PropTypes from 'prop-types';
import './Blog.scss';
import AppImages from '../../Utils/ThemeImages';
import { useNavigate } from 'react-router-dom';
import blogsData from './BlogsData';
import { Helmet } from 'react-helmet';

const Blog = () => {

  const navigate = useNavigate()

  const canonicalUrl = "https://whitetowerinternational.com/Blogs";
 

  return (
    <div className="Blog">
      <Helmet>
        <link rel="canonical" href={canonicalUrl} />
        <title>White Tower - Blog</title>
      </Helmet>
      <div className="main-blog-section">
        <section className="blog-section-1">
          <div className="inner-blog-section-1">
            <div className="container">
              <div className="blog-section-1-head">
                <h1>BLOGS</h1>
              </div>
            </div>
          </div>
        </section>
        <section className="blog-section-2">
          <div className="inner-blog-section-2">
            <div className="container">
              <div className="main-blogs-grid grid grid-cols-3 gap-5">
                {blogsData.map((items , index) => {
                  return (
                    <button className="flex flex-col single-blog-blk wow animate__animated animate__fadeInUp text-left" key={index} onClick={() => navigate(`/SingleBlog/${items.uniqueId}`, { state: { blogData: items } })} >
                      <div className="inner-blog-image relative">
                        <img src={items.image} className='w-full' alt="" />
                        <div className="blog-date-secton">
                          <h4>{items.category} | <span> {items.date}</span></h4>
                        </div>
                      </div>
                      <div className="bottom-blog-content-section">
                        <h4>{items.title}</h4>
                        <p>{items.content}</p>
                        <button className='read-more-btn-nlog'><p>Read More</p></button>
                      </div>
                    </button>
                  )
                })} 
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  )
}

Blog.propTypes = {};

Blog.defaultProps = {};

export default Blog;
